/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// JSX If statements
const isFunction = (input) => typeof input === 'function';

export default function RenderIf(predicate) {
    return (elemOrThunk) => {
        if (predicate) {
            return isFunction(elemOrThunk) ? elemOrThunk() : elemOrThunk;
        }
        return null;
    };
}
